import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import addressesKeys from '../util/addresses-keys';

export interface CreateAddressProps {
  name: string;
  address: {
    street: string;
    city: string;
    state: string;
    streetNumber: number;
    neighborhood: string;
    zipcode: string;
    latitude: number;
    longitude: number;
  };
  isCompanyBase: boolean;
  isPublic: boolean;
}

const useCreateAddress = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: CreateAddressProps) => {
    create(addressesKeys.list(), data);
  };

  return useApiMutation<CreateAddressProps>({
    url: '/addresses',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar endereço',
    successTitle: 'Cadastrar endereço',
    successMessage: 'Endereço cadastrado com sucesso',
    redirectUrl: '/settings/addresses',
    onSuccess,
  });
};

export default useCreateAddress;
